//  export const translation = {
//     es: {
//       title: "Restablecer Contraseña",
//       subtitle: "Ingresa tu nueva contraseña",
//       newPassword: "Nueva Contraseña",
//       confirmPassword: "Confirmar Contraseña",
//       resetButton: "Restablecer Contraseña",
//       passwordError: "Las contraseñas no coinciden",
//       successMessage: "Contraseña actualizada correctamente. Redirigiendo...",
//       errorMessage: "Error al restablecer la contraseña",
//       tokenExpired: "El enlace ha expirado o es inválido",
//       switchLang: "Cambiar a Inglés",
//       passwordRequirements: "La contraseña debe contener:",
//       minLength: "Al menos 8 caracteres",
//       uppercase: "Una letra mayúscula",
//       lowercase: "Una letra minúscula",
//       number: "Un número",
//       specialChar: "Un carácter especial",
//       noSpaces: "Sin espacios",
//     },
//     en: {
//       title: "Reset Password",
//       subtitle: "Enter your new password",
//       newPassword: "New Password",
//       confirmPassword: "Confirm Password",
//       resetButton: "Reset Password",
//       passwordError: "Passwords do not match",
//       successMessage: "Password updated successfully. Redirecting...",
//       errorMessage: "Error resetting password",
//       tokenExpired: "The link has expired or is invalid",
//       switchLang: "Switch to Spanish",
//       passwordRequirements: "Password must contain:",
//       minLength: "At least 8 characters",
//       uppercase: "An uppercase letter",
//       lowercase: "A lowercase letter",
//       number: "A number",
//       specialChar: "A special character",
//       noSpaces: "No spaces",
//     },
//   };

export const translation = {
  es: {
    title: "Restablecer contraseña",
    subtitle: "Crea una nueva contraseña segura",

    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    resetButton: "Restablecer contraseña",

    passwordRequirements: "Tu contraseña debe contener:",
    minLength: "• Al menos 8 caracteres",
    uppercase: "• Al menos una letra mayúscula (A-Z)",
    lowercase: "• Al menos una letra minúscula (a-z)",
    number: "• Al menos un número (0-9)",
    specialChar: "• Al menos un carácter especial (!@#$%)",
    noSpaces: "• Sin espacios",

    passwordInvalid: "La contraseña no cumple todos los requisitos",
    passwordError: "Las contraseñas no coinciden",

    errorMessage: "Ocurrió un error, intenta de nuevo",

    tokenExpired: "El enlace ha expirado",
    requestNewLink: "Por favor solicita un nuevo enlace de restablecimiento.",
    requestButton: "Solicitar nuevo enlace",

    successMessage: "Tu contraseña ha sido restablecida exitosamente",
  },

  en: {
    title: "Reset Password",
    subtitle: "Create a new secure password",

    newPassword: "New password",
    confirmPassword: "Confirm password",
    resetButton: "Reset password",

    passwordRequirements: "Your password must include:",
    minLength: "• At least 8 characters",
    uppercase: "• At least one uppercase letter (A-Z)",
    lowercase: "• At least one lowercase letter (a-z)",
    number: "• At least one number (0-9)",
    specialChar: "• At least one special character (!@#$%)",
    noSpaces: "• No spaces",

    passwordInvalid: "The password does not meet all requirements",
    passwordError: "Passwords do not match",

    errorMessage: "An error occurred, please try again",

    tokenExpired: "The link has expired",
    requestNewLink: "Please request a new reset link.",
    requestButton: "Request new link",

    successMessage: "Your password has been successfully reset",
  },
};
